import {ObjectDTO} from '../object-dto';

export default class VarianteDTO extends ObjectDTO {

  libelle: string;

}
